// projects/humanresources-personnel/src/assets/i18n/*/hr-per-certificate.json
export class HrPerCertificateKey {
    private static readonly keyPrefix = 'hrPerCertificate';
    public static title = `${HrPerCertificateKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerCertificateKey.keyPrefix}.pageHeader`;
    public static documentType = `${HrPerCertificateKey.keyPrefix}.documentType`;
    public static enumDocumentTypes = `${HrPerCertificateKey.keyPrefix}.enumDocumentTypes`;
    public static educationPlace = `${HrPerCertificateKey.keyPrefix}.educationPlace`;
    public static enumEducationPlaces = `${HrPerCertificateKey.keyPrefix}.enumEducationPlaces`;
    public static educationPlaceText = `${HrPerCertificateKey.keyPrefix}.educationPlaceText`;
    public static enumUnit = `${HrPerCertificateKey.keyPrefix}.enumUnit`;
    public static educationTime = `${HrPerCertificateKey.keyPrefix}.educationTime`;
    public static unit = `${HrPerCertificateKey.keyPrefix}.unit`;
    public static parentLocation = `${HrPerCertificateKey.keyPrefix}.parentLocation`;
}
